<!-- Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. -->
<dialog-titlebar></dialog-titlebar>

<tp-stepper
	*ngIf="{ currentStep: currentStep$ | async } as vm"
	[steps]="steps"
	[currentStep]="(currentStepConfig$ | async)?.displayIndex || vm.currentStep"
	[minimalisticHeader]="(currentStepConfig$ | async)?.minimalisticHeader"
>
	<mat-divider class="padded-divider"></mat-divider>

	<ng-container [ngSwitch]="currentStep$ | async">
		<ng-container *ngSwitchCase="stateStep.INITIAL">
			<import-tickets-upload-step
				#ticketUploadStep
				[planId]="dialogData.planId"
				(openDataSourceSettings)="onOpenDataSourceSettings()"
			>
			</import-tickets-upload-step>
		</ng-container>
		<ng-container *ngSwitchCase="stateStep.VALIDATE">
			<import-tickets-validation-results-step></import-tickets-validation-results-step>
		</ng-container>
		<ng-container *ngSwitchCase="stateStep.TICKET_CORRECTION">
			<import-tickets-ticket-correction></import-tickets-ticket-correction>
		</ng-container>
		<ng-container *ngSwitchCase="stateStep.INSERTION_POINT">
			<import-tickets-insertion-point-step></import-tickets-insertion-point-step>
		</ng-container>
		<ng-container *ngSwitchCase="stateStep.ESID_DISAMBIGUATION">
			<esid-disambiguation></esid-disambiguation>
		</ng-container>
		<ng-container *ngSwitchCase="stateStep.MAP_VARIANCE_REASONS">
			<import-tickets-variances></import-tickets-variances>
		</ng-container>
		<ng-container *ngSwitchCase="stateStep.RESULTS">
			<import-tickets-results-step></import-tickets-results-step>
		</ng-container>
	</ng-container>
</tp-stepper>

<!-- Loading state -->
<ng-template [loadingBlocker]="isLoading$ | async"></ng-template>
